/* Contenu de la bulle d'une collecte sur la carte.
   - Construit en éléments DOM et en texte (textContent) : les réponses saisies
     par les Spotters ne sont jamais interprétées comme du HTML.
   - Sans le nom du Spotter (décision Tribe : le client voit le nombre de
     Spotters, jamais leur identité).
   - Réponses au format réel [{ label, valeur }] (donnees/collectes). Les photos
     ne se chargent qu'avec le jeton : la bulle en donne le nombre et renvoie à
     l'onglet Résultats. */
import {
  Collecte, LIBELLE_STATUT_COLLECTE, lireReponses, nomPhoto, photosDeLaCollecte, texteReponse,
} from '../donnees/collectes';

export type CollecteCarte = Pick<Collecte, 'statut' | 'createdAt' | 'photoUrl' | 'reponsesJson'>;

export { LIBELLE_STATUT_COLLECTE, texteReponse };

/** Adresse d'image acceptée seulement en http(s) : ni javascript:, ni data:. */
export function urlImageSure(url: unknown): string | null {
  if (typeof url !== 'string' || !url.trim()) return null;
  try {
    const u = new URL(url.trim());
    return u.protocol === 'https:' || u.protocol === 'http:' ? u.href : null;
  } catch {
    return null;
  }
}

const element = <K extends keyof HTMLElementTagNameMap>(balise: K, classe?: string, texte?: string) => {
  const el = document.createElement(balise);
  if (classe) el.className = classe;
  if (texte != null) el.textContent = texte;
  return el;
};

/** Une réponse est une liste de photos si chacune de ses valeurs est un nom de fichier image. */
const estListeDePhotos = (v: unknown) => Array.isArray(v) && v.length > 0 && v.every(x => nomPhoto(x) != null);

export function contenuBulleCollecte(c: CollecteCarte, formatDate: (iso?: string) => string): HTMLElement {
  const racine = element('div', 'bulle-collecte');

  const statut = c.statut ? LIBELLE_STATUT_COLLECTE[c.statut] ?? 'Statut inconnu' : 'Statut inconnu';
  racine.appendChild(element('div', `bulle-collecte__statut bulle-collecte__statut--${c.statut ?? 'inconnu'}`, statut));

  const infos = element('dl', 'bulle-collecte__infos');
  const ajouter = (libelle: string, valeur: string) => {
    infos.appendChild(element('dt', undefined, libelle));
    infos.appendChild(element('dd', undefined, valeur));
  };
  ajouter('Date', formatDate(c.createdAt));
  for (const r of lireReponses(c.reponsesJson)) {
    if (estListeDePhotos(r.valeur)) continue;
    ajouter(r.label, texteReponse(r.valeur));
  }
  const photos = photosDeLaCollecte({ id: '', ...c });
  if (photos.length > 0) {
    ajouter('Photos', `${photos.length} — à voir dans l'onglet Résultats`);
  }
  racine.appendChild(infos);
  return racine;
}
